import { useMemo, useState } from 'react';

import Icon from '~/components/icon';
import Logo from '~/components/Logo';
import MiniMyOC from '~/components/myoddschecker/components/mini-myoc';
import { useLayoutStore } from '~/providers/layout-store-provider';
import { useLoaderContext } from '~/providers/loader-context';
import { useModalContext } from '~/providers/modal-context';
import { useMyOCContext } from '~/providers/myoc-context';
import TrackingActions, {
  TRACKING_ACTIONS,
  TRACKING_CATEGORIES,
  TRACKING_EVENTS,
  TRACKING_LABELS } from
'~/services/actions/tracking-actions';

import { TertiaryHeaderNavGroup } from '../TertiaryHeaderNavGroup';

import Drawer from './sub-components/drawer';
import styles from './HeaderMobile.module.css';

export const HeaderMobile = () => {
  const mobileHamburgerNav = useLayoutStore((s) => s.navData.mobileHamburgerNav);
  const repub = useLayoutStore((s) => s.repub);
  const resourcesUrl = useLayoutStore((s) => s.resourcesUrl);

  const [{ showMyOC }] = useModalContext();
  const { myocData } = useMyOCContext();
  const loaderData = useLoaderContext();

  const [navDrawerOpen, setNavDrawerOpen] = useState(false);

  const trackingActions = useMemo(() => new TrackingActions(), []);

  const handleNavClick = () => {
    setNavDrawerOpen(!navDrawerOpen);

    trackingActions.eventTracking({
      event: TRACKING_EVENTS.HAMBURGER_MENU_CLICK,
      eventCategory: TRACKING_CATEGORIES.NAVIGATION,
      eventAction: TRACKING_ACTIONS[TRACKING_EVENTS.HAMBURGER_MENU_CLICK],
      eventLabel: TRACKING_LABELS[TRACKING_EVENTS.HAMBURGER_MENU_CLICK]
    });
  };

  return (
    <>
			<header className={styles.mobileHeader} data-testid="header-mobile-v2">
				<nav className={`${styles.navBar}`}>
					<div className={styles.burgerLogo}>
						<button data-testid="hamburger-menu" onClick={handleNavClick}>
							<Icon className={styles.burgerIcon} icon="HamburgerMenu" />
						</button>
						<a className={styles.iconWrapper} href={`/${repub.toLowerCase()}/`}>
							<Logo resourcesUrl={resourcesUrl} />
						</a>
					</div>
					{showMyOC &&
          <MiniMyOC
            loaderData={loaderData}
            myocData={myocData}
            type="burgerTop" />

          }
				</nav>
				<div className={styles.subMenu}>
					<TertiaryHeaderNavGroup />
				</div>
			</header>
			<Drawer
        isOpen={navDrawerOpen}
        pages={mobileHamburgerNav}
        path={'/'}
        toggleDrawer={handleNavClick} />

		</>);

};